import React, { useContext, useState } from 'react';
import * as S from './styled';
import Form from '../..';
import { ValidityContext } from '../../../../provider/ValidityProvider';
import {
  defaultBlurValidityForm,
  defaultValidityForm,
} from '../../../../store/validity/utils';
import { DropdownItem } from '../../../Input/InputDropdown';
import { maskFieldDate, unmaskFieldDate } from '../utils';
import {
  formatFloat,
  formatInteger,
  formatNumber,
  unformatFloat,
} from '../../../../store/masks';
import TextArea from '../../../TextArea';

export default function FormValidityCreate() {
  const {
    validities,
    filterProducts,
    validateForm,
    getFormMessage,
    getValidity,
    setValidity,
    enqueueSnackbar,
    filterBranches,
    branches,
    createValidity,
    filterValidities,
    setModal,
    filterValidityStatusValidity,
  } = useContext(ValidityContext)!.controllers.validity;
  const form = getValidity(`forms.validity.create`);

  const blurField = (field: keyof ValidityForm) => () => {
    setValidity(`blur.validity.create.${field}`, true);
  };

  const products = getValidity('filters.products.data.data');
  const validityStatus = getValidity('filters.validityStatus.data');
  const messages = getFormMessage('validity.create');

  const [productLoading, setProductLoading] = useState(false);
  const searchProducts = (e) => {
    setProductLoading(true);
    filterProducts(e.target.value).finally(() => {
      setProductLoading(false);
    });
  };

  const [productValue, setProductValue] = useState(
    form.subProductId
      ? `${form.subProductId} - ${form.productShortDescription} - ${form.barcodeNumber}`
      : '',
  );

  const [statusLoading, setStatusLoading] = useState(false);
  const [statusValue, setStatusValue] = useState(form.statusName);

  const [branchValue, setBranchValue] = useState(
    form.branchCode ? `${form.branchCode} - ${form.branchName}` : '',
  );

  const [quantity, setQuantity] = useState(
    form.exitPackaging === 'KG' ? form.quantity.toFixed(3) : `${form.quantity}`,
  );

  const [branchLoading, setBranchLoading] = useState(false);

  const filterBranch = (e) => {
    setBranchLoading(true);
    filterBranches(e.target.value).finally(() => {
      setBranchLoading(false);
    });
  };

  const filterStatus = (e) => {
    setStatusLoading(true);
    filterValidityStatusValidity(e.target.value).finally(() => {
      setStatusLoading(false);
    });
  };

  const productItems: DropdownItem[] = products.map((product) => ({
    id: product.subProductId,
    name: `${product.subProductId} - ${product.productShortDescription} - ${product.barcodeNumber}`,
    data: product,
  }));

  const statusItems: DropdownItem[] = [
    {
      id: 'pending',
      name: 'PENDENTE',
      data: {
        id: 'pending',
        name: 'PENDENTE',
        color: '#FF0050',
      },
    },
    ...validityStatus.map((status) => ({
      id: status.id,
      name: status.name,
      data: status,
    })),
  ];

  const branchItems = branches.map((branch: Branch) => ({
    id: branch.id,
    name: `${branch.code} - ${branch.name}`,
    data: branch,
  }));

  const selectProduct = ({
    productId,
    subProductId,
    productFullDescription,
    productShortDescription,
    sectionId,
    sectionDescription,
    barcodeNumber,
    exitPackaging,
  }: EsProduct) => {
    setValidity('forms.validity.create', {
      ...form,
      productId,
      subProductId,
      productShortDescription,
      productFullDescription,
      sectionId,
      sectionDescription,
      barcodeNumber,
      exitPackaging,
    });
    setProductValue(
      `${subProductId} - ${productShortDescription} - ${barcodeNumber}`,
    );
    setQuantity(
      exitPackaging === 'KG' ? Number(quantity).toFixed(3) : `${quantity}`,
    );
  };

  const selectStatus = ({ name, color }: ValidityStatus) => {
    setValidity('forms.validity.create', {
      ...form,
      statusColor: color,
      statusName: name,
    });
    setStatusValue(name);
  };

  const selectBranch = ({ code, name }: Branch) => {
    setValidity('forms.validity.create', {
      ...form,
      branchCode: code,
      branchName: name,
    });
    setBranchValue(`${code} - ${name}`);
  };

  const clearForm = () => {
    const validityForm = defaultValidityForm();
    setValidity(`forms.validity.create`, validityForm);
    setValidity(`blur.validity.create`, defaultBlurValidityForm());
    setQuantity(`0`);
    setProductValue('');
    setStatusValue('PENDENTE');
    setBranchValue('');
  };

  const [createLoading, setCreateLoading] = useState(false);
  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setCreateLoading(true);
    validateForm('validity.create')
      .then(() => {
        createValidity()
          .then((validity) => {
            setValidity(`filters.validities.data.data`, [
              ...validities,
              validity,
            ]);
            clearForm();
            setModal('single.createValidity', false);
            setTimeout(() => {
              filterValidities();
            }, 1000);
            enqueueSnackbar('Validade criada com sucesso', {
              variant: 'success',
            });
          })
          .catch(() => {
            enqueueSnackbar('Houve uma falha ao criar a validade', {
              variant: 'error',
            });
          })
          .finally(() => {
            setCreateLoading(false);
          });
      })
      .catch(() => {
        enqueueSnackbar('Verifique a validade dos campos', {
          variant: 'error',
        });
        setCreateLoading(false);
      });
  };
  return (
    <S.Form
      style={{
        maxHeight: '80vh',
      }}
      onSubmit={onSubmit}
    >
      <S.Body>
        <S.Grid>
          <Form.Input.Dropdown
            label="Produto"
            items={productItems}
            value={productValue}
            onDebouncedChange={searchProducts}
            onChange={(e) => {
              setProductValue(e.target.value);
            }}
            onBlur={() => {
              blurField('productShortDescription')();
              setProductValue(
                form.subProductId
                  ? `${form.subProductId} - ${form.productShortDescription} - ${form.barcodeNumber}`
                  : '',
              );
            }}
            error={messages.productShortDescription}
            onSelected={({ data }) => selectProduct(data)}
            loading={productLoading}
          />
          <Form.Input
            label="Quantidade"
            value={quantity}
            onChange={(e) => {
              const value = e.target.value;
              setQuantity(value);
              setValidity('forms.validity.create', {
                ...form,
                quantity:
                  form.exitPackaging === 'KG'
                    ? unformatFloat(value)
                    : formatNumber(value),
              });
            }}
            error={messages.quantity}
            onBlur={blurField('quantity')}
            mask={form.exitPackaging === 'KG' ? formatFloat : formatInteger}
          />
          <Form.Input.DatePicker
            label="Validade"
            value={maskFieldDate(form.validity)}
            onChange={(e) => {
              setValidity('forms.validity.create', {
                ...form,
                validity: unmaskFieldDate(e.target.value),
              });
            }}
            error={messages.validity}
            onBlur={blurField('validity')}
          />
          <Form.Input.Dropdown
            label="Status"
            items={statusItems}
            value={statusValue}
            onDebouncedChange={filterStatus}
            onSelected={({ data }) => selectStatus(data)}
            onChange={(e) => {
              setStatusValue(e.target.value);
            }}
            error={messages.statusName}
            onBlur={() => {
              blurField('statusName')();
              setStatusValue(form.statusName);
            }}
            loading={statusLoading}
          />
          <Form.Input.Dropdown
            label="Filial"
            items={branchItems}
            value={branchValue}
            onChange={(e) => {
              setBranchValue(e.target.value);
            }}
            onBlur={() => {
              blurField('branchCode')();
              setBranchValue(
                form.branchCode
                  ? `${form.branchCode} - ${form.branchName}`
                  : '',
              );
            }}
            onDebouncedChange={filterBranch}
            error={messages.branchCode}
            onSelected={({ data }) => selectBranch(data)}
            loading={branchLoading}
          />
        </S.Grid>
        <div style={{ padding: '0 20px' }}>
          <TextArea
            label="Observação"
            value={form.observation}
            onChange={(e) => {
              setValidity('forms.validity.create', {
                ...form,
                observation: e.target.value,
              });
            }}
          />
        </div>
      </S.Body>
      <S.Actions>
        <Form.Button type="button" onClick={clearForm}>
          Limpar
        </Form.Button>
        <Form.Button loading={createLoading}>Criar</Form.Button>
      </S.Actions>
    </S.Form>
  );
}
